<script>
</script>

<section class="container">
    <div class="header">
        <h1>Psychoterapia <br /> psychodynamiczna</h1>
    </div>
</section>

<style>
    .header {
        align-items: flex-start;
        align-self: flex-start;
        padding: 0 10%;
        display: flex;
        background-image: url("/back-optimised.webp");
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }
    .header h1 {
        color: #ebf1ff;
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
        font-family: "Times New Roman", Times, serif;
        flex: 1;
        text-align: start;
            font-size: 3.5em;
        margin-block-start: 1.3em;
        @media screen and (min-width: 1050px) {
            font-size: 3.5em;
        }
    }
</style>
